import { renderer as button } from './sections/button';
import { renderer as category_carousel } from './sections/categoryCarousel';
import { renderer as content_tiles } from './sections/contentTiles';
import { renderer as copy_block } from './sections/copyBlock';
import { renderer as department_hero_banner } from './sections/departmentHeroBanner';
import { renderer as hero_banner } from './sections/heroBanner';
import { renderer as links_block } from './sections/linksBlock';
import { renderer as masonry_carousel } from './sections/masonryCarousel';
import { renderer as partner_block } from './sections/partnerBlock';
import { renderer as preview_error } from './sections/previewError';
import { renderer as product_carousel } from './sections/productCarousel';
import { renderer as product_carousel_recommendations } from './sections/productCarouselRecommendations';
import { renderer as section_title } from './sections/sectionTitle';
import { renderer as standard_banner } from './sections/standardBanner';
import { renderer as tile_carousel } from './sections/tileCarousel';
import { renderer as video_block } from './sections/videoBlock';

export const renderers = {
  button,
  category_carousel,
  content_tiles,
  copy_block,
  department_hero_banner,
  hero_banner,
  links_block,
  masonry_carousel,
  partner_block,
  preview_error,
  product_carousel,
  product_carousel_recommendations,
  section_title,
  standard_banner,
  tile_carousel,
  video_block,
};

export type ContentBlockRendererType = keyof typeof renderers;
